import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { Submission } from "domain/entities/submission";
import { FormSubmissionInputFilter } from "domain/models/nimberforms-input-filters";
import { Logger } from "infra/logger/logger"
import submissionRepository from "infra/repositories/submission-repository";

export const useGetSubmissionsByFilter = (filter: FormSubmissionInputFilter, options?: {enabled?: boolean}) => {
    const logger = Logger.getInstance();

    return useQuery({
            queryKey: ["FormsSubmission", filter],
            queryFn: async () => {
                try {
                    const result = await submissionRepository.getByFilter(filter);
                    return result;
                } catch (error: any) {
                    if (error instanceof AxiosError) {
                        logger.error(
                        error.response?.data.metadata.errors[0],
                        error.response?.data.metadata
                        );
                    throw new Error(error.response?.data.metadata.errors);
                    }
                    throw error;
                }
            },
            enabled: options?.enabled ?? true
        });
}
export const useCreateSubmissionMutation = () =>{
    const logger = Logger.getInstance();
    const submissionQuery = useQueryClient()

    return useMutation({
        mutationFn: async (submission: Submission) => {
            const result = await submissionRepository.create(submission);
            return result;
        },
        onSuccess: () => {
            submissionQuery.invalidateQueries({queryKey: ["FormsSubmission", {}]});
        },
        onError: (error) => {
            if (error instanceof AxiosError) {
                console.log("raw error:", error)
                if (error.response?.data?.metadata?.errors) {
                    const errors = error.response.data.metadata.errors;
                    logger.error(errors[0], error.response?.data.metadata);
                    console.log("error axios",errors[0]);
                    //Cria um objeto de erro com o array de erros como propriedade
                    const customError = new Error("Erro ao criar submission");
                    (customError as any).errors = errors; // Adiciona o array de erros ao objeto de erro
                    throw customError;
                } else {
                    throw new Error("Erro desconhecido da API");
                }
                }else {
                    logger.error("Erro desconhecido", error);
                    throw error;
                }
        }
    });
}